/**
 * @generated SignedSource<<e7601b07b65953e832597f621057e13c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefetchContainer_shippingFilters$data = ReadonlyArray<{
  readonly totalCount: number | null;
  readonly " $fragmentType": "SbSharedRefetchContainer_shippingFilters";
}>;
export type SbSharedRefetchContainer_shippingFilters$key = ReadonlyArray<{
  readonly " $data"?: SbSharedRefetchContainer_shippingFilters$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefetchContainer_shippingFilters">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SbSharedRefetchContainer_shippingFilters",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "type": "ShippingFilterType",
  "abstractKey": null
};

(node as any).hash = "d5ad44746e573a35fa3db0693e7d384d";

export default node;
